import { render, staticRenderFns } from "./customerDetail.vue?vue&type=template&id=e3c439c8&scoped=true&"
import script from "./customerDetail.vue?vue&type=script&lang=js&"
export * from "./customerDetail.vue?vue&type=script&lang=js&"
import style0 from "./customerDetail.vue?vue&type=style&index=0&id=e3c439c8&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3c439c8",
  null
  
)

export default component.exports